import { MobileBottomNavigationContainer, Provider } from '@cian/frontend-mobile-bottom-navigation';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectRegionId } from '../../selectors/regionId';
import { useApplicationContext } from '../ApplicationContext';

export const BottomNavigationContainer = () => {
  const {
    httpApi,
    logger,
    config,
    custom: { subdomain, userId },
  } = useApplicationContext();

  const regionId = useSelector(selectRegionId);

  const isMobileBottomNavigationFromHeaderEnabled =
    config.get<boolean>('header-frontend.mobileBottomNavigation.Enabled') ?? false;

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  if (isMobileBottomNavigationFromHeaderEnabled || !isMobileBottomNavigationEnabled) {
    return null;
  }

  return (
    <Provider context={{ httpApi, logger }}>
      <MobileBottomNavigationContainer
        pageType="main"
        subdomain={subdomain}
        region={regionId}
        isAuthenticated={Boolean(userId)}
      />
    </Provider>
  );
};
